import React from "react";
import "./waxing.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function Waxing() {
  return (
    <>
    <Helmet>
      <title>Best Car Waxing Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Give your car a deep, glossy finish with professional car waxing services at AutoCare in Palwal. We provide premium car repair & detailing solutions for long-lasting paint protection."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/waxing"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT SECTION */}
        <div className="textContent">
          <h1>Best Car Waxing Service in Palwal</h1>

          <p>
            Give your car a deep, glossy finish with
            <strong> professional car waxing services</strong> at
            <span className="highlight"> AutoCare</span>.
            We are a trusted <span className="highlight">Auto Care in Palwal</span>
            providing premium <strong>car repair & detailing solutions</strong>
            for long-lasting paint protection.
          </p>

          <h2>What is Car Waxing?</h2>
          <p>
            Car waxing is a protective treatment that adds a smooth,
            shiny layer over your car’s paint. It protects against dust,
            sunlight, pollution, and minor scratches while enhancing gloss.
          </p>

          <h2>Benefits of Professional Car Waxing</h2>
          <ul>
            <li>Long-lasting paint protection</li>
            <li>Deep glossy showroom shine</li>
            <li>Protects paint from UV rays & pollution</li>
            <li>Makes car washing easier</li>
            <li>Improves overall car appearance</li>
          </ul>

          <h2>Why Choose AutoCare for Car Waxing?</h2>
          <ul>
            <li>One of the <span className="highlight">best car waxing services in Palwal</span></li>
            <li>Premium wax products & professional tools</li>
            <li>Experienced detailing specialists</li>
            <li>Affordable pricing & transparent service</li>
            <li>Reliable <span className="highlight">Auto Care in Palwal</span> for car repair</li>
          </ul>

          <h2>Book Car Waxing Near You</h2>
          <p>
            Looking for the <span className="highlight">best car waxing near me</span>?
            Choose <strong>AutoCare</strong> for professional results,
            long-lasting shine, and trusted car care services.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Car Waxing Service
            </Link>
          </button>
        </div>

        {/* IMAGE SECTION */}
        <div className="imageContent">
          <img
            src="/carServiceImages/waxing.webp"
            alt="Best Car Waxing Service in Palwal by AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
